var map = {
	"./actor-chaplin-comedy-svgrepo-com.svg": 7660,
	"./addicted-draw-love-svgrepo-com.svg": 2389,
	"./afro-avatar-male-2-svgrepo-com.svg": 476,
	"./afro-avatar-male-svgrepo-com.svg": 1697,
	"./afro-boy-child-svgrepo-com.svg": 7693,
	"./afro-female-person-svgrepo-com.svg": 7884,
	"./alien-avatar-space-svgrepo-com.svg": 381,
	"./animal-avatar-bear-svgrepo-com.svg": 5856,
	"./animal-avatar-mutton-svgrepo-com.svg": 1587,
	"./anime-away-face-svgrepo-com.svg": 4766,
	"./apple-avatar-illness-svgrepo-com.svg": 7076,
	"./artist-avatar-marilyn-svgrepo-com.svg": 3553,
	"./avatar-avocado-food-svgrepo-com.svg": 4713,
	"./avatar-bad-breaking-svgrepo-com.svg": 5948,
	"./avatar-batman-comics-svgrepo-com.svg": 9275,
	"./avatar-boy-kid-svgrepo-com.svg": 3360,
	"./avatar-boy-male-svgrepo-com.svg": 9605,
	"./avatar-bug-insect-svgrepo-com.svg": 5910,
	"./avatar-cacti-cactus-svgrepo-com.svg": 1135,
	"./avatar-child-girl-svgrepo-com.svg": 9596,
	"./avatar-cloud-crying-svgrepo-com.svg": 549,
	"./avatar-coffee-cup-svgrepo-com.svg": 6498,
	"./avatar-dead-monster-svgrepo-com.svg": 1626,
	"./avatar-einstein-professor-svgrepo-com.svg": 5886,
	"./avatar-elderly-grandma-svgrepo-com.svg": 1203,
	"./avatar-female-girl-svgrepo-com.svg": 8474,
	"./avatar-female-portrait-2-svgrepo-com.svg": 5436,
	"./avatar-female-portrait-svgrepo-com.svg": 9713,
	"./avatar-geisha-japanese-svgrepo-com.svg": 2106,
	"./avatar-hindi-indian-svgrepo-com.svg": 9737,
	"./avatar-joker-squad-svgrepo-com.svg": 1953,
	"./avatar-lazybones-sloth-svgrepo-com.svg": 3461,
	"./avatar-male-man-svgrepo-com.svg": 4101,
	"./avatar-male-ozzy-svgrepo-com.svg": 4653,
	"./avatar-male-president-svgrepo-com.svg": 9233,
	"./avatar-man-muslim-svgrepo-com.svg": 8045,
	"./avatar-man-person-svgrepo-com.svg": 6503,
	"./avatar-muslim-paranja-svgrepo-com.svg": 3512,
	"./avatar-nun-sister-svgrepo-com.svg": 5257,
	"./avatar-person-pilot-svgrepo-com.svg": 2535,
	"./baby-child-kid-svgrepo-com.svg": 7611,
	"./beard-hipster-male-svgrepo-com.svg": 505,
	"./boy-indian-kid-svgrepo-com.svg": 1312,
	"./builder-helmet-worker-svgrepo-com.svg": 6865,
	"./child-girl-kid-svgrepo-com.svg": 9607,
	"./christmas-clous-santa-svgrepo-com.svg": 8402,
	"./fighter-luchador-man-svgrepo-com.svg": 6426,
	"./friday-halloween-jason-svgrepo-com.svg": 1052,
	"./indian-male-man-svgrepo-com.svg": 6915,
	"./indian-man-sikh-svgrepo-com.svg": 9127,
	"./male-man-old-svgrepo-com.svg": 2577
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5766;